import holidayFormTemplate from './holiday-form.template.html';

let HolidayModalFactory = function ($uibModal, $translate) {

  let holidayForm = (acl, holidayData, callback, negative, deleteCallback) => {
    let modal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: holidayFormTemplate,
      controller: ['$scope', 'BranchService', 'UserBranchService', 'User',($scope, BranchService, UserBranchService, User) => {
        $scope.acl = acl;
        $scope.model = holidayData;
        $scope.isInEditMode = !!holidayData;
        $scope.titleKey = $scope.isInEditMode ? 'editHoliday' : 'createHoliday';
        $scope.loading = false;
        $scope.today = moment().format('YYYY-MM-DD 12:00:00');
        $scope.loggedInUser = User.getUser().id
        $scope.todayMinDate = {
          minDate: $scope.today
        }

        const init = () => {
          return UserBranchService.getUserBranches($scope.loggedInUser)
            .then((data) => {
              if (data && data.results) {
                
                if ($scope.isInEditMode) {
                  $scope.branches = data.results
                    .filter((branch) => {
                      return branch.branchId === $scope.model.branch;
                    })
                    .map((branch) => {
                      branch.ticked = true;
                      return branch;
                    });
                }
                else {
                  $scope.branches = data.results;
                }
              }
            });
        };

        $scope.isDisabledDate = function (currentDate, mode) {
          if ($scope.model.startDate > $scope.model.endDate) {
            $scope.model.endDate = $scope.model.startDate
          }
          else if ($scope.model.startDate == null) {
            $scope.model.endDate = null
          }
          $scope.effectiveMinDate = {
            minDate: $scope.model.startDate
          }
        }

        $scope.save = () => {
          $scope.loading = true;
          $scope.model.branch = $scope.model.branch.map((branchObj) => branchObj.branchId)
          callback({
            $scope,
            modal
          });
        };

        $scope.cancel = () => {
          negative({
            modal
          });
        };

        $scope.delete = () => {
          $scope.model.branch = $scope.model.branch.map((branchObj) => branchObj.branchId)[0];
          deleteCallback({
            $scope,
            modal
          });
        };

        init()
          .then(() => {
            
            $scope.$watch(() => {
              if ($scope.model) {
                return $scope.model.startDate;
              }
            }, (nv, ov) => {
              if (!ov && nv) {
                $scope.model.startDate = moment($scope.model.startDate).format('YYYY-MM-DD 12:00:00')
                $scope.model.endDate  = moment($scope.model.endDate).format('YYYY-MM-DD 23:59:59')
                $scope.model.endDate = moment($scope.model.startDate).format('YYYY-MM-DD 23:59:59')
              }
            });
          });
      }]
    });
  };

  return {
    holidayForm
  };
};

HolidayModalFactory.$inject = ['$uibModal', '$translate'];

export default HolidayModalFactory;


// WEBPACK FOOTER //
// ./client/app/components/holiday/modal/modal.factory.js